import { TextField, TextFieldProps } from '@mui/material';

const BaseTextField = ({ fullWidth, ...rest }: TextFieldProps) => (
  <TextField
    fullWidth
    {...rest}
    slotProps={{ ...rest.slotProps, inputLabel: { ...rest.slotProps?.inputLabel, shrink: true } }}
  />
);

export { BaseTextField as TextField };
